// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-navigation-drawer.sidedar-content{overflow:hidden;z-index:11}.v-navigation-drawer .area-scroll{overflow-y:auto;height:100%}.btn-close{background:hsla(0,0%,100%,.1)}.sidebar-context.container.grid-list-xs{padding:2px}", ""]);
// Exports
module.exports = exports;
